import type { CategoryScoringMap } from "../dto";
import { Question } from "./Question";

export type QuestionSetType = "Fct" | "Rct" | "Fir" | "Lir";

export class QuestionSet {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly type: QuestionSetType,
    public readonly questions: Question[],
    public readonly scoringPerCategory: CategoryScoringMap,
    public readonly createdAt: Date,
    public readonly updatedAt: Date,
  ) {}

  static fromJson(json: any): QuestionSet {
    return new QuestionSet(
      json["id"],
      json["name"],
      json["type"],
      json["questions"] ? json["questions"].map((q: any) => Question.fromJson(q)) : [],
      json["default_category_scores"]?.["scoring_per_score_category"] ?? {},
      new Date(json["created_at"]),
      new Date(json["updated_at"]),
    );
  }
}
